import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { Meta } from "@/@types/paginated";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { useGetStoreEmailQuery, useLazyGenerateStoreEmailExcelReportQuery } from "@/services/conciliation/store-email";
import { downloadExcel } from "@/utils/download-excel";
import { handeOrderBy } from "@/utils/pagination";
import { Button } from "components/ui/button";
import { toast } from "components/ui/use-toast";
import { FileSpreadsheet, Plus, RefreshCw } from "lucide-react";
import AddEmailToStore from "./add";
import { columns } from "./components/columns";
import { DataTable } from "./components/data-table";
import { useFilterState } from "./filter/hooks/filterState";
import { Load } from "components/load";
import PageError from "components/page-error";

const StoreEmail = () => {
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };
  const orderBy = handeOrderBy(filters.order);
  const [trigger] = useLazyGenerateStoreEmailExcelReportQuery();

  const { data: storeEmailData, refetch, isLoading, isFetching, error } = useGetStoreEmailQuery({
    search: filters.search,
    orderBy: JSON.stringify(orderBy),
    page: filters?.meta?.page || 1,
    perPage: filters?.meta?.perPage || 10,
    meta: {
      page: filters?.meta?.page || 1,
      perPage: filters?.meta?.perPage || 10,
    },
  });

  const handleExport = async () => {
    try {
      const result = await trigger({
      }).unwrap();

      downloadExcel(result.excelFile, `emails-de-loja.xlsx`);

      toast({
        variant: "default",
        description: "Arquivo gerado com sucesso!",
        duration: 2000,
      });
    } catch (error) {
      toast({
        variant: "destructive",
        description: "Erro ao gerar o relatório.",
      });
    }
  };

  const { handleModal } = useDialogModal();

  const handleOpenModal = () => {
    handleModal({
      isOpen: true,
      element: <AddEmailToStore />,
      title: "Adicionar Emails à Loja",
    });
  };

  const { data, meta } = storeEmailData ?? { data: [], meta: {} };

  if (isLoading) return <Load />;
  if (error) {
    return <PageError status={500} message={"ERRO INTERNO NO SERVIDOR"} />;
  }

  return (
    <PageLayout>
      <PageTitle
        title="Configuração de Emails"
        description="Configure quais os emails das lojas"
      />
      <ContentContainer>
        <DataTable columns={columns} data={data} meta={meta as Meta} isLoading={isLoading || isFetching} />
      </ContentContainer>
      <div className="flex flex-wrap gap-3 justify-between w-full">
        <div className="flex flex-wrap gap-3">
          <Button
            variant="outline"
            onClick={refetch}
            className="border-[#613F4F] text-[#613F4F] hover:bg-[#613F4F]/10"
          >
            <RefreshCw className="mr-2 h-4 w-4" /> Atualizar Filtros
          </Button>
        </div>
        <div className="flex flex-wrap gap-3">
          <Button
            onClick={handleOpenModal}
            className="bg-[#613F4F] text-white hover:bg-[#613F4F]/90"
          >
            <Plus className="mr-2 h-4 w-4" /> Adicionar Email
          </Button>
          <Button onClick={handleExport} className="bg-[#F6D040] text-[#613F4F] hover:bg-[#F6D040]/90">
            <FileSpreadsheet className="mr-2 h-4 w-4" /> Download Excel
          </Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default StoreEmail;
